import React, { useEffect, createElement } from 'react';
import { KidsMartialArtsHeroInfo } from './kids-martial-arts/KidsMartialArtsHeroInfo';
import { KidsMartialArtsHeroForm } from './kids-martial-arts/KidsMartialArtsHeroForm';
import { KidsMartialArtsBridge } from './kids-martial-arts/KidsMartialArtsBridge';
import { KidsMartialArtsBenefits } from './kids-martial-arts/KidsMartialArtsBenefits';
import { KidsMartialArtsWhatYouLearn } from './kids-martial-arts/KidsMartialArtsWhatYouLearn';
import { KidsMartialArtsReviews } from './kids-martial-arts/KidsMartialArtsReviews';
import { KidsMartialArtsScheduleLocation } from './kids-martial-arts/KidsMartialArtsScheduleLocation';
import { KidsMartialArtsFAQHeader } from './kids-martial-arts/KidsMartialArtsFAQHeader';
import { KidsMartialArtsFAQQuestions } from './kids-martial-arts/KidsMartialArtsFAQQuestions';
import { KidsMartialArtsFAQActions } from './kids-martial-arts/KidsMartialArtsFAQActions';
import { KidsMartialArtsRelatedLinks } from './kids-martial-arts/KidsMartialArtsRelatedLinks';
import { KidsMartialArtsFinalCTA } from './kids-martial-arts/KidsMartialArtsFinalCTA';
export function KidsMartialArts() {
  useEffect(() => {
    document.title = 'Kids Martial Arts Classes Farmington Hills | Storm Taekwondo';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Beginner-friendly kids martial arts classes near Farmington Hills, Novi and Commerce. Help your child build confidence, discipline and focus. Free trial available.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Beginner-friendly kids martial arts classes near Farmington Hills, Novi and Commerce. Help your child build confidence, discipline and focus. Free trial available.';
      document.head.appendChild(meta);
    }
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-2318">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-2319">
        <div className="absolute inset-0 opacity-20" data-id="element-2320">
          <img src="https://images.unsplash.com/photo-1517438476312-10d79c077509?auto=format&fit=crop&w=2000&q=80" alt="Taekwondo Background" className="block w-full h-full object-cover" data-id="element-2321" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-2322" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2323">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-2324">
            <KidsMartialArtsHeroInfo data-id="element-2325" />

            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-2326">
              <KidsMartialArtsHeroForm data-id="element-2327" />
            </div>
          </div>
        </div>
      </section>
      <KidsMartialArtsBridge data-id="element-2328" />
      <KidsMartialArtsBenefits data-id="element-2329" />
      <KidsMartialArtsWhatYouLearn data-id="element-2330" />
      <KidsMartialArtsReviews data-id="element-2331" />
      <KidsMartialArtsScheduleLocation data-id="element-2332" />
      <section className="py-24 bg-off-white" data-id="element-2333">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2334">
          <KidsMartialArtsFAQHeader data-id="element-2335" />
          <KidsMartialArtsFAQQuestions data-id="element-2336" />
          <KidsMartialArtsFAQActions data-id="element-2337" />
        </div>
      </section>
      <KidsMartialArtsRelatedLinks data-id="element-2338" />
      <KidsMartialArtsFinalCTA data-id="element-2339" />
    </div>;
}